import BrandingUpgradeBanner from 'FormsUI/components/common/BrandingUpgradeBanner';
import { MAX_ROWS_ABOVE_PQL_ROW } from './constants';
const PqlRow = ({
  page,
  rowIndex
}) => {
  const isFirstPage = page === 0;
  const isSecondRow = rowIndex === MAX_ROWS_ABOVE_PQL_ROW;
  const pqlRow = BrandingUpgradeBanner({
    upgradeKey: 'forms-remove-branding-index'
  });
  const showPqlRow = pqlRow !== null && isFirstPage && isSecondRow;
  return showPqlRow ? pqlRow : null;
};
export default PqlRow;